import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { TextField } from "@episerver/ui-framework";

const DurationField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, setValue, errors } = props;

    const convertToString = (val: any) => {
        if (val) {
            const _val = parseInt(val);
            const hours = _val / 60 < 10 ? `0${Math.round(_val / 60)}` : Math.round(_val / 60);
            const minutes = _val % 60 < 10 ? `0${_val % 60}` : _val % 60;
            return `${hours}:${minutes}`;
        } else {
            return "00:00";
        }
    };

    useEffect(() => {
        setValue(`extendedProperties[${index}].value`, convertToString(property.value));
    }, []);

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            rules={{
                required: {
                    value: !property.isNullable,
                    message: `${property.friendlyName} is required`,
                },
                pattern: {
                    value: /^\s*(([0-9]*[:\s]+([0-5]?[0-9]))|((2[0-4])|([01]?[0-9])))\s*$/i,
                    message: `${property.friendlyName} is invalid`,
                },
            }}
            render={({ field: { onChange, value } }) => (
                <TextField
                    id={`extendedProperties[${index}].value`}
                    type="text"
                    outlined
                    label={property.friendlyName}
                    helperText={errors.extendedProperties ? errors.extendedProperties[index]?.value?.message ?? property.description : property.description}
                    invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                    value={value ?? ""}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default DurationField;
